const initState = function () {
  return {
    transportMode: null,
    journeyDirection: null,
    dollyType: null,
    incotermId: null,
    shippingFeatures: {
      dollarToDominicanPeso: null,
      shipmentValue: {
        value: null,
        unitMeasurement: null
      },
      container20:
      {
        units: null,
        totalWeight: {
          value: null,
          unitMeasurement: null
        }
      },
      container40:
      {
        units: null,
        totalWeight: {
          value: null,
          unitMeasurement: null
        }
      },
      container45:
      {
        units: null,
        totalWeight: {
          value: null,
          unitMeasurement: null
        }
      },
      pallets:
      {
        units: null,
        totalWeight: {
          value: null,
          unitMeasurement: null
        }
      }
    },
    pathCharacteristics: {
      dispatchDate: null,
      availablePath: {
        originCountryId: null,
        destinationCountryId: null,
        originTerminalId: null,
        originCityId: null,
        destinationTerminalId: null,
        destinationCityId: null,
        transportMode: null
      }
    },
    costComponents: {
      inlandTransportation: {
        isGroundTransportationService: true,
        waitingTimeForCharging: null,
        hasHolidays: null,
        hasOverloadOrDimension: null,
        hasCirculationPermits: null,
        needToPayTolls: null,
        rentChassis: null,
        isInspectionCostForUseOwnChassis: null,
        rentalDays: 0,
        daysUseInImport: 0,
        tollPrice: null
      },
      internationalTransport: {
        freightIncludesTerminalCosts: null,
        freightIncludesGroundTransportationOutsideRD: null,
        quoteCurrency: null,
        freightAddress: null
      },
      terminalManagement: {
        thcPort: null,
        loadVerification: null,
        portSecurity: null,
        refrigeratedLoadElectricalConnection: null,
        internalMovementCostsYard: null,
        penaltyDifferencesWeighing: null,
        fumigationServiceAuthorizationMinSalud: null,
        penaltyTemporaryStorage: null,
        XRayInspection: null,
        furgonTransfer: null,
        loadingLashingVehicle: null,
        noObjectionFumigatedContainers: null,
        containerImportAgriculturePermit: null,
        additionalDays: 0,
        portImprovementRate: null

      },
      airportManagement: {
        airportTaxesAndRampHandling: null,
        rXinspectionExpenses: null,
        warehouseManagement: null,
        warehouseManagementLaborUseMinutes: 0,
        warehouseManagementCheck: null,
        servicesHandler: null,
        awb: null,
        storageDays: 0,
        forkliftService: null,
        forkliftServiceMinutes: null,
        usePalletJack: null,
        usePalletJackHours: null,
        truckStowage: null
      },
      administrationFees: {
        hasBLOrAWLCost: null,
        hasFreightForwarderServices: null,
        customsAgentServices: null,
        cleaningFee: null
      },
      proceduresAndPermits: {
        dua: null,
        plantHealthInspection: null,
        animalHealthInspection: null,
        dispatchFreeTradeZone: null,
        customsServiceFee: null,
        customsInspection: null,
        customsInspectionExpenses: null
      },
      taxesAndFees: {
        hasDGARateOrAgricultureRate: null,
        originCertificatesIssuance: null,
        itbisImports: null,
        selectiveConsumptionTax: null,
        gravamen: null,
        selectiveConsumptionTaxValue: null
      },
      financialAndAdministrativeCosts: {
        isExchangeRateVariationCosts: null,
        isFinancingTransportOperation: null,
        isCommissionBrokers: null,
        isBankOperationRate: null,
        isCreditLettersIssuance: null,
        estimatedDaysDelay: 0,
        isContainerDelayPenalty: null,
        isChassisDeliveryDelayPenalty: null,
        isAdditionalPrivateSecurityHiring: null
      },
      insuranceAndExtras: {
        seaFreightImportInsurance: null,
        isInsured: null,
        NumberPrivateSecurityUnits: null
      },
      receptionLogistics: {
        merchandiseHandlingReceipt: null,
        nonReeferWarerhouse: null,
        refrigeratedStorage: null,
        warerhouseDays: null,
        valueAddedServices: null,
        warehouseEnvironmentTransport: null,
        customsBroker: null,
        merchandiseHandlingClearance: null,
        travelCarriageNecessary: null,
        averageHaulingDistance: null
      },
      shippingLogistic: {
        isPickingAndPacking: null,
        isConsolidationTemporaryStorage: null,
        consolidationTemporaryStorageMonths: null,
        isCarriageVergeConsolidation: null,
        travelCarriageNecessary: null,
        averageHaulingDistance: null
      }
    }
  }
}

const transportChainCostStore = {
  state: {
    showResult: false,
    transportChainScenario: { ...initState() }
  },
  mutations: {
    setShowResult (state, status) {
      state.showResult = status
    },
    setShippingOptions (state, shippingOptions) {
      state.transportChainScenario.pathCharacteristics.availablePath.transportMode = shippingOptions.transportMode
      state.transportChainScenario.transportMode = shippingOptions.transportMode
      state.transportChainScenario.journeyDirection = shippingOptions.direction
      state.transportChainScenario.dollyType = shippingOptions.dollyType
    },
    setShippingFeatures (state, shippingFeatures) {
      state.transportChainScenario.shippingFeatures = shippingFeatures
    },
    setResetInsuranceAndExtras (state) {
      state.transportChainScenario.costComponents.insuranceAndExtras = { ...initState().costComponents.insuranceAndExtras }
    },
    setResetShippingLogistic (state) {
      state.transportChainScenario.costComponents.shippingLogistic = { ...initState().costComponents.shippingLogistic }
    },
    setResetShippingLogisticAirportManagement (state) {
      state.transportChainScenario.costComponents.shippingLogistic.isConsolidationTemporaryStorage = initState().costComponents.shippingLogistic.isConsolidationTemporaryStorage
      state.transportChainScenario.costComponents.shippingLogistic.consolidationTemporaryStorageMonths = initState().costComponents.shippingLogistic.consolidationTemporaryStorageMonths
      state.transportChainScenario.costComponents.shippingLogistic.isCarriageVergeConsolidation = initState().costComponents.shippingLogistic.isCarriageVergeConsolidation
      state.transportChainScenario.costComponents.shippingLogistic.travelCarriageNecessary = initState().costComponents.shippingLogistic.travelCarriageNecessary
      state.transportChainScenario.costComponents.shippingLogistic.averageHaulingDistance = initState().costComponents.shippingLogistic.averageHaulingDistance
    },
    setResetReceptionLogistics (state) {
      state.transportChainScenario.costComponents.receptionLogistics = { ...initState().costComponents.receptionLogistics }
    },
    setResetReceptionLogisticsAirportManagement (state) {
      state.transportChainScenario.costComponents.receptionLogistics.nonReeferWarerhouse = initState().costComponents.receptionLogistics.nonReeferWarerhouse
      state.transportChainScenario.costComponents.receptionLogistics.refrigeratedStorage = initState().costComponents.receptionLogistics.refrigeratedStorage
      state.transportChainScenario.costComponents.receptionLogistics.valueAddedServices = initState().costComponents.receptionLogistics.valueAddedServices
      state.transportChainScenario.costComponents.receptionLogistics.warehouseEnvironmentTransport = initState().costComponents.receptionLogistics.warehouseEnvironmentTransport
      state.transportChainScenario.costComponents.receptionLogistics.customsBroker = initState().costComponents.receptionLogistics.customsBroker
      state.transportChainScenario.costComponents.receptionLogistics.merchandiseHandlingClearance = initState().costComponents.receptionLogistics.merchandiseHandlingClearance
      state.transportChainScenario.costComponents.receptionLogistics.travelCarriageNecessary = initState().costComponents.receptionLogistics.travelCarriageNecessary
      state.transportChainScenario.costComponents.receptionLogistics.averageHaulingDistance = initState().costComponents.receptionLogistics.averageHaulingDistance
      state.transportChainScenario.costComponents.receptionLogistics.warerhouseDays = initState().costComponents.receptionLogistics.warerhouseDays
    },
    setResetInlandTransportation (state) {
      state.transportChainScenario.costComponents.inlandTransportation = { ...initState().costComponents.inlandTransportation }
    },
    setResetAdministrationFees (state) {
      state.transportChainScenario.costComponents.administrationFees = { ...initState().costComponents.administrationFees }
    },
    setResetProceduresAndPermits (state) {
      state.transportChainScenario.costComponents.proceduresAndPermits = { ...initState().costComponents.proceduresAndPermits }
    },
    setResetTaxesAndFees (state) {
      state.transportChainScenario.costComponents.taxesAndFees = { ...initState().costComponents.taxesAndFees }
    },
    setResetTerminalManagement (state) {
      state.transportChainScenario.costComponents.terminalManagement = { ...initState().costComponents.terminalManagement }
    },
    setResetAirportManagement (state) {
      state.transportChainScenario.costComponents.airportManagement = { ...initState().costComponents.airportManagement }
    },
    setResetInternationalTransport (state) {
      state.transportChainScenario.costComponents.internationalTransport = { ...initState().costComponents.internationalTransport }
    },
    setResetShippingFeatures (state) {
      state.transportChainScenario.shippingFeatures = { ...initState().shippingFeatures }
    },
    setResetPathCharacteristics (state) {
      state.transportChainScenario.pathCharacteristics = { ...initState().pathCharacteristics }
    },
    resetTransportChainCostStore (state) {
      state.transportChainScenario = { ...initState() }
      state.showResult = false
    },
    setIncoterm (state, incoterm) {
      state.transportChainScenario.incotermId = incoterm
    },
    setPathCharacteristics (state, pathCharacteristics) {
      state.transportChainScenario.pathCharacteristics = pathCharacteristics
    },
    setReceptionLogistics (state, receptionLogistics) {
      state.transportChainScenario.costComponents.receptionLogistics = receptionLogistics
    },
    setShippingLogistic (state, shippingLogistic) {
      state.transportChainScenario.costComponents.shippingLogistic = shippingLogistic
    },
    setFinancialAndAdministrativeCosts (state, financialAndAdministrativeCosts) {
      state.transportChainScenario.costComponents.financialAndAdministrativeCosts = financialAndAdministrativeCosts
    },
    setInsuranceAndExtras (state, insuranceAndExtras) {
      state.transportChainScenario.costComponents.insuranceAndExtras = insuranceAndExtras
    },
    setInlandTransportation (state, inlandTransportation) {
      state.transportChainScenario.costComponents.inlandTransportation = inlandTransportation
    },
    setAdministrationFees (state, administrationFees) {
      state.transportChainScenario.costComponents.administrationFees = administrationFees
    },
    setProceduresAndPermits (state, proceduresAndPermits) {
      state.transportChainScenario.costComponents.proceduresAndPermits = proceduresAndPermits
    },
    setTaxesAndFees (state, taxesAndFees) {
      state.transportChainScenario.costComponents.taxesAndFees = taxesAndFees
    },
    setTerminalManagement (state, terminalManagement) {
      state.transportChainScenario.costComponents.terminalManagement = terminalManagement
    },
    setAirportManagement (state, airportManagement) {
      state.transportChainScenario.costComponents.airportManagement = airportManagement
    },
    setInternationalTransport (state, internationalTransport) {
      state.transportChainScenario.costComponents.internationalTransport = internationalTransport
    },
    setCleaningFee (state, status) {
      state.transportChainScenario.costComponents.administrationFees.cleaningFee = status
    }
  },

  actions: {

  },

  getters: {
    availablePath: state => state.transportChainScenario.pathCharacteristics.availablePath,
    transportMode: state => state.transportChainScenario.transportMode,
    journeyDirection: state => state.transportChainScenario.journeyDirection,
    dollyType: state => state.transportChainScenario.dollyType,
    storeShippingFeatures: state => state.transportChainScenario.shippingFeatures,
    incoterm: state => state.transportChainScenario.incotermId,
    storePathCharacteristics: state => state.transportChainScenario.pathCharacteristics,
    receptionLogisticsStore: state => state.transportChainScenario.costComponents.receptionLogistics,
    shippingLogisticsStore: state => state.transportChainScenario.costComponents.shippingLogistic,
    financialAndAdministrativeCostsStore: state => state.transportChainScenario.costComponents.financialAndAdministrativeCosts,
    insuranceAndExtrasStore: state => state.transportChainScenario.costComponents.insuranceAndExtras,
    inlandTransportationStore: state => state.transportChainScenario.costComponents.inlandTransportation,
    administrationFeesStore: state => state.transportChainScenario.costComponents.administrationFees,
    proceduresAndPermitsStore: state => state.transportChainScenario.costComponents.proceduresAndPermits,
    taxesAndFeesStore: state => state.transportChainScenario.costComponents.taxesAndFees,
    terminalManagementStore: state => state.transportChainScenario.costComponents.terminalManagement,
    airportManagementStore: state => state.transportChainScenario.costComponents.airportManagement,
    internationalTransportStore: state => state.transportChainScenario.costComponents.internationalTransport
  }
}
export default transportChainCostStore
